/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { EyeClosedIcon16Light } from './EyeClosedIcon16Light';
import { EyeClosedIcon16Regular } from './EyeClosedIcon16Regular';
import { EyeClosedIcon16Solid } from './EyeClosedIcon16Solid';
import { EyeClosedIcon20Light } from './EyeClosedIcon20Light';
import { EyeClosedIcon20Regular } from './EyeClosedIcon20Regular';
import { EyeClosedIcon20Solid } from './EyeClosedIcon20Solid';
import { EyeClosedIcon24Regular } from './EyeClosedIcon24Regular';
import { EyeClosedIcon24Solid } from './EyeClosedIcon24Solid';
import { EyeClosedIcon32Regular } from './EyeClosedIcon32Regular';
import { EyeClosedIcon64Regular } from './EyeClosedIcon64Regular';
var sizes = {
    16: {
        light: EyeClosedIcon16Light,
        regular: EyeClosedIcon16Regular,
        solid: EyeClosedIcon16Solid,
    },
    20: {
        light: EyeClosedIcon20Light,
        regular: EyeClosedIcon20Regular,
        solid: EyeClosedIcon20Solid,
    },
    24: {
        regular: EyeClosedIcon24Regular,
        solid: EyeClosedIcon24Solid,
    },
    32: {
        regular: EyeClosedIcon32Regular,
    },
    64: {
        regular: EyeClosedIcon64Regular,
    },
};
export var EyeClosedIcon = forwardRef('EyeClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
